import PropTypes from 'prop-types';
import { useRef } from 'react';

export default function Form(props) {
	const textareaRef = useRef(null);

	return (
		<div className="blog-feedback__form">
			<div className="form-field">
				<label htmlFor="message">{props.labels.form_textarea_label}</label>
				<textarea id="message" name="message" rows="6" ref={textareaRef}></textarea>
			</div>
			<button onClick={() => props.submitForm(textareaRef.current.value)} className="btn btn--primary">
				{props.labels.form_button}
			</button>
		</div>
	);
}

Form.propTypes = {
	labels: PropTypes.object,
	submitForm: PropTypes.func,
};
